import type { Step } from "src/ui/components/StepList/StepList";
import { StepStatus } from "src/ui/components/StepList/StepList";

const steps: Omit<Step, "context">[] = [
  {
    label: "onboardingExpectation.firstLabel.label",
    title: "onboardingExpectation.firstBullet.title",
    subtitle: "onboardingExpectation.firstBullet.description",
    status: StepStatus.IN_PROGRESS
  },
  {
    label: "onboardingExpectation.secondLabel.label",
    title: "onboardingExpectation.secondBullet.title",
    subtitle: "onboardingExpectation.secondBullet.description",
    status: StepStatus.LOCKED
  },
  {
    label: "onboardingExpectation.thirdLabel.label",
    title: "onboardingExpectation.thirdBullet.title",
    subtitle: "onboardingExpectation.thirdBullet.description",
    status: StepStatus.LOCKED,
    showLastLine: true
  }
];

export default steps;
